import moment from 'moment';
import { Card } from 'primereact/card';
import PropTypes from 'prop-types';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { withTranslation } from 'react-i18next';
import NumberFormat from 'react-number-format';
import BaseListContainer from '../baseContainers/BaseListContainer';
import CriteriaCalendarRangeComponent from '../components/criteria/CriteriaCalendarRangeComponent';
import CriteriaMultiSelectComponent from '../components/criteria/CriteriaMultiSelectComponent';
import CriteriaNumberRangeComponent from '../components/criteria/CriteriaNumberRangeComponent';
import CriteriaTextComponent from '../components/criteria/CriteriaTextComponent';
import CustomDialog from '../components/CustomDialog';
import { CustomMessages } from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import BlockUi from '../components/waitPanel/BlockUi';
import { baseReportCsv, baseReportPdf, baseXLSXReport, currencyFormat } from '../report/ReportUtils';
import TransactionService from '../services/TransactionService';
import TransactionDialog from './TransactionDialog';
import MenuItemIcon from '../components/MenuItemIcon';
import { TabView, TabPanel } from 'primereact/tabview';
import HlsPlayerCustomBar from '../components/HlsPlayerCustomBar';
import { ProgressSpinner } from 'primereact/progressspinner';

class TransactionListContainer extends BaseListContainer {
    constructor(props) {
        super(props, new TransactionService());
        this.state = {
            list: [],
            selectedList: [],
            selectAll: false,
            loading: true,
            size: 0,
            first: 0,
            petrolOptions: [],
            serviceOptions: [],
            productOptions: [],
            criteria: this.getCleanSearchCriteria(),
            filters: {},
            dialogVisibile: false,
            videoDialogVisibile: false,
            element: null,
            video: null,
            transactionVideoResponse: undefined,
            playerActiveIndex: 0,
            videoLoading: false,
            notificationList: [],
            refreshKey: 0,
        };
        this.pollingTimeoutId = null;
        this.pollingActive = false;
        this.handleTabChange = this.handleTabChange.bind(this);
        this.USE_WEBSOCKET = true; 
    }
    componentDidMount() {
        const ws = this.props.webSocket;
        if (ws !== undefined) {
            ws.addEventListener('message', this.handleWebSocketMessage);
        }
        super.componentDidMount();
    }

    componentWillUnmount() {
        const ws = this.props.webSocket;
        if (ws !== undefined) {
            ws.removeEventListener('message', this.handleWebSocketMessage);
        }
        super.componentWillUnmount?.();
    }

    getListTitle() {
        return 'transaction.listTitle';
    }

    updateSearchCriteria(criteria) {
        return {
            phoneNumber: this.props.phoneNumber,
            dateFrom: criteria.dateFrom ? new Date(criteria.dateFrom) : undefined,
            dateTo: criteria.dateTo ? new Date(criteria.dateTo) : undefined,
            amountFrom: criteria.amountFrom,
            amountTo: criteria.amountTo,
            filter: criteria.filter,
            petrols: criteria.petrols,
            services: criteria.services,
            products: criteria.products,
            firstResult: criteria.firstResult,
            maxResults: criteria.maxResults,
            sortField: criteria.sortField,
            sortAsc: criteria.sortAsc,
        };
    }

    getCleanSearchCriteria(selectAll) {
        return {
            phoneNumber: this.props.phoneNumber,
            dateFrom: this.props.hideFilters || selectAll ? undefined : moment(new Date()).subtract(90, 'days').toDate(),
            dateTo: undefined,
            amountFrom: undefined,
            amountTo: undefined,
            unInvoiced: this.props.unInvoiced,
            filter: '',
            petrols: [],
            services: [],
            products: [],
            firstResult: 0,
            maxResults: 10,
            sortField: 'date_time',
            sortAsc: false,
        };
    }

    //override
    getCleanSearchCriteriaPrototype() {
        const criteria = this.getCleanSearchCriteria();
        criteria.petrols = this.state.petrolOptions;
        criteria.services = this.state.serviceOptions;
        criteria.products = this.state.productOptions;
        criteria.amountFrom = this.state.criteria.amountFrom;
        criteria.amountTo = this.state.criteria.amountTo;
        return criteria;
    }

    initializeFromBackend() {
        const {t} = this.props;
        if (this._isMounted && !this.props.hideFilters && this.isUserInRole('ROLE_FLEET')) {
            this.service
                .getFleetGoodGroups()
                .then((response) => {
                    this.setState({
                        petrolOptions: response.petrols,
                        serviceOptions: response.services,
                        productOptions: response.products,
                    });
                })
                .catch(() => {
                    this.showErrorMessage(t('error.fleetGoodGroupListErr'));
                });
        }
    }

    getCriteriaName() {
        return 'transaction-list-sc';
    }

    getContainerListName() {
        return 'transaction-list-container';
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    handleValidForm() {
        this.unblockUi();
    }

    handleTabChange(e) {
       const newIndex = typeof e === 'number' ? e : e.index;
        this.setState(
            {
                playerActiveIndex: newIndex,
            }
        );
    }

    renderCriteria() {
        const {t} = this.props;
        return (
            <div className='row'>
                <CriteriaTextComponent
                    id='filter-sc'
                    name='filter'
                    label={''}
                    colClass='col-lg-6 col-sm-6'
                    value={this.state.criteria.filter}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    showLabel={false}
                    placeholder={t('transaction.textFilter')}
                    iconSvg='ico_cards_magnifying_glass'
                    iconSize='cards-magnifying-glass'
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                />
                <CriteriaCalendarRangeComponent
                    id='date-sc'
                    idFrom='dateFrom-sc'
                    idTo='dateTo-sc'
                    name='date'
                    nameFrom='dateFrom'
                    nameTo='dateTo'
                    label={t('transaction.transactionDate')}
                    colClass='col-xl-6 col-lg-6 col-sm-6'
                    from={this.state.criteria.dateFrom}
                    to={this.state.criteria.dateTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    refreshFromBackend
                    showButtonBar
                    sharedLabel
                    renderDash
                    placeholderFrom={t('cards.from')}
                    placeholderTo={t('cards.to')}
                    inputsClassName='col-6'
                />
                <CriteriaNumberRangeComponent
                    idFrom='amountFrom-sc'
                    idTo='amountTo-sc'
                    nameFrom='amountFrom'
                    nameTo='amountTo'
                    renderDash
                    label={t('invoice.amountFilter')}
                    labelFrom={''}
                    labelTo={''}
                    showButtons={false}
                    colClass='col-lg-3 col-sm-6'
                    from={this.state.criteria.amountFrom}
                    to={this.state.criteria.amountTo}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    inputsClassName='col-6'
                    refreshFromBackend
                    timeoutHandler={this.refreshTable}
                    allowEmpty
                />
                <CriteriaMultiSelectComponent
                    id='petrols-sc'
                    name='petrols'
                    showClear
                    label={t('transaction.petrols')}
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.petrols}
                    dataKey='petraId'
                    optionLabel={(element) => t(`products.${element.name}`)}
                    options={this.state.petrolOptions}
                    placeholder={t('list.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    timeoutHandler={this.refreshTable}
                    refreshFromBackend
                />
                <CriteriaMultiSelectComponent
                    id='services-sc'
                    name='services'
                    showClear
                    label={t('transaction.services')}
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.services}
                    dataKey='petraId'
                    optionLabel={(element) => t(`products.${element.name}`)}
                    options={this.state.serviceOptions}
                    placeholder={t('list.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    timeoutHandler={this.refreshTable}
                    refreshFromBackend
                />
                <CriteriaMultiSelectComponent
                    id='products-sc'
                    name='products'
                    showClear
                    label={t('transaction.products')}
                    colClass='col-lg-3 col-sm-6'
                    value={this.state.criteria.products}
                    dataKey='petraId'
                    optionLabel={(element) => t(`products.${element.name}`)}
                    options={this.state.productOptions}
                    placeholder={t('list.all')}
                    onChange={this.handleChangeSc}
                    validator={this.validator}
                    timeoutHandler={this.refreshTable}
                    refreshFromBackend
                />
            </div>
        );
    }

    getDataKey() {
        return 'petraId';
    }

    getProductListTemplate(data) {
        const { t } = this.props;
        let isHighwayTransaction = data.transactionType === 3;
        let isEvTransaction = data.transactionType === 2;
        if (isHighwayTransaction) {
            return <MenuItemIcon
                id={`${data.id}-highways-icon`}
                className={'product-label-highways'}
                //className={`product-label white-text`}
                iconSvg={'ico_car_highways_list_black'}
            />
        } else if (isEvTransaction) {
            if (data?.positions?.length > 0) {
                return [data?.positions[0]].map((pos) => (
                    <div
                        key={`product-${pos.name}`}
                        className={`product-label ${pos.color ? 'white-text' : 'black-text'}`}
                        style={{ background: pos.color }}
                        iconSvg={"ico_car_highways_btn"}
                    >
                        {t(`products.${pos.name}`)}
                    </div>
                ));
            }
        } else if (data.positionsSorted?.length > 0) {
            return data?.positionsSorted?.map((pos) => (
                <div
                    key={`product-${pos.name}`}
                    className={`product-label ${pos.color ? 'white-text' : 'black-text'}`}
                    style={{ background: pos.color }}
                    iconSvg={"ico_car_highways_btn"}
                >
                    {t(`products.${pos.name}`)}
                </div>
            ));
        } else return null;
    }

    getQuantityListTemplate(list){
        const {t} = this.props;
        let isHighwayTransaction = list.transactionType === 3;
        if(isHighwayTransaction){
            return list.quantity;
        } else if (list.positionsSorted?.length > 0){
            return list?.positionsSorted?.map((pos) => (
                <NumberFormat
                    key={`transaction.quantity-${pos.name}-${pos.quantity}`}
                    value={pos.quantity}
                    displayType={'text'}
                    thousandSeparator=' '
                    decimalSeparator=','
                    fixedDecimalScale
                    decimalScale={pos.measureUnit === 'ITEM' || pos.measureUnit === 'BOX' ? 0 : 2}
                    renderText={(value) => (
                        <div
                            className='product-quantity-label'
                            dangerouslySetInnerHTML={{__html: `${value} ${t(`measureUnit.${pos.measureUnit}`)}`}}
                        />
                    )}
                />
            ))
        } else { 
            return null;

        }

       
    }

    prepareColumns() {
        const {t} = this.props;
        return [
            {
                field: 'dateTime',
                header: t('transaction.date'),
                sortable: true,
                body: this.dateTemplate.bind(this, 'dateTime', 'DD-MM-YYYY[\n]HH:mm:ss'),
                bodyClassName: 'date',
                sortField: 'date_time',
            },
            {field: 'cardNumber', header: t('transaction.cardNumber'), sortable: true, sortField: 'card_no'},
            {field: 'registrationNumber', header: t('transaction.registrationNumber'), sortable: true, sortField: 'reg_no'},
            {field: 'driver', header: t('transaction.fullName'), sortable: true, sortField: 'driver'},
            {field: 'stationName', header: t('transaction.city'), sortable: true, sortField: 'station'},
            {field: 'stationNumber', header: t('transaction.stationNumber'), sortable: true, sortField: 'station_no'},
            {
                body: (list) => this.getProductListTemplate(list),
                key: 'fuel',
                header: t('transaction.product'),
            },
            {
                key: 'quantity',
                header: t('transaction.quantity'),
                body: (list) => this.getQuantityListTemplate(list),
                bodyClassName: 'number-value',
            },
            {
                field: 'amount',
                header: t('transaction.amount'),
                sortable: true,
                body: this.amountTemplate.bind(this, 'amount'),
                bodyClassName: 'number-value',
                sortField: 'value_tot',
            },
            {field: 'video', header: t('transaction.video'), body: this.videoTemplate.bind(this), sortable: false},
            {
                key: 'actions',
                header: '',
                body: this.actionTemplate,
                className: 'table-column-action',
            },
        ];
    }

    stopPolling = () => {
        this.pollingActive = false;
        if (this.pollingTimeoutId) {
            clearTimeout(this.pollingTimeoutId);
            this.pollingTimeoutId = null;
        }
    };

    countVideoActiveIndex(video) {
        const { playerActiveIndex } = this.state;
        const videoWithIndex = video.map((v, index) => ({ ...v, index }));
        const indexWithReady = videoWithIndex.find(v => v.videoRecordPartStatus === "READY")?.index;
        const isActiveReady = videoWithIndex.some(
            v => v.index === playerActiveIndex && v.videoRecordPartStatus === "READY"
        );

        if (!isActiveReady && indexWithReady !== undefined) {
            return indexWithReady;
        } else {
            return playerActiveIndex;
        }


    }

    handleClickOnVideo = (rowData, e) => {
    if (e) e.preventDefault();

    this.stopPolling(); // zatrzymujemy polling jeśli działa

    // pokazujemy dialog i spinner
    this.setState({
        videoDialogVisibile: true,
        videoLoading: true,
        element: rowData,
    });

    // startujemy streaming
    this.service.checkTransactionVideoStartStreaming({
        petraId: rowData.petraId,
        cardNumber: rowData.cardNumber,
        dateTime: rowData.dateTime,
        subscribedPetraId: rowData.petraId,
    })
    .then((res) => {
        this.setState({ transactionVideoResponse: res });

        const anyReady = res.videos.some(v => v.videoRecordPartStatus === 'READY');
        const allError = res.videos.every(v => v.videoRecordPartStatus === 'ERROR');

        if (anyReady) {
            const activeIndex = this.countVideoActiveIndex(res?.videos);
            this.setState({
                videoLoading: false,
                video: res.videos,
                playerActiveIndex: activeIndex,
            });
        } else if (allError) {
            this.setState({
                videoLoading: false,
                videoDialogVisibile: false
            });
            this.showErrorMessage("Błąd podczas pobierania nagrań z serwera");
        } else {
            if (this.USE_WEBSOCKET) {
               //czekamy na status READY z WS i nic nie robimy
            } else {
                // polling zamiast WS - co 3-5 sekund
                this.pollingTimeoutId = setTimeout(() => {
                    this.pollTransactionVideoStatus(rowData);
                }, 3000);
            }
        }

    })
    .catch(() => {
        this.setState({ videoLoading: false });
        this.showErrorMessage("Błąd podczas pobierania nagrań z serwera");
    });
};

    pollTransactionVideoStatus = (rowData, startTime = Date.now()) => {
        const { t } = this.props;
        this.pollingActive = true;
        const pollInterval = 3000;
        const maxPollTime = 15000;

        this.service.checkTransactionVideoPartsStatus({
            petraId: rowData.petraId,
            cardNumber: rowData.cardNumber,
            dateTime: rowData.dateTime,
        })
            .then((res) => {
                if (!this.pollingActive) return;

                this.setState({ transactionVideoResponse: res });

                const parts = res.videos;
                const status = res.status;
                const anyReady = parts.some(p => p.videoRecordPartStatus === 'READY');
                const allError = res.videos.every(v => v.videoRecordPartStatus === 'ERROR') || status === "ERROR";

                if (anyReady) {
                    // jeśli choć jedna część READY - otwieram dialog od razu
                    this.setState({
                        videoLoading: false,
                        video: parts,
                        videoDialogVisibile: true,
                        element: rowData
                    }, () => this.unblockUi());
                } else if (allError) {
                    this.setState({ videoLoading: false, videoDialogVisibile: false }, () => this.unblockUi());
                    this.showErrorMessage("Błąd podczas pobierania nagrań z serwera");
                    this.stopPolling();
                }
                else {
                    // jeśli wciąż nic nie gotowe - kontynuuję polling
                    const elapsed = Date.now() - startTime;
                    if (elapsed < maxPollTime) {
                        setTimeout(() => this.pollTransactionVideoStatus(rowData, startTime), pollInterval);
                    } else {
                        this.setState({ videoLoading: false, videoDialogVisibile: false }, () => this.unblockUi());
                        this.showErrorMessage("Błąd podczas pobierania nagrań z serwera");
                        this.stopPolling();
                    }
                }
            })
            .catch(() => {
                if (!this.pollingActive) return;
                this.setState({ videoLoading: false }, () => this.unblockUi());
                this.showErrorMessage("Błąd podczas pobierania nagrań z serwera");
                this.stopPolling();
            });
    };


    handleWebSocketMessage = (evt) => {
        const message = JSON.parse(evt.data);
        if (message.operation !== 'NOTIFICATION_UPDATE') return;
        const { element, transactionVideoResponse } = this.state;


        this.setState((prevState) => {
            const updatedList = prevState.list.map((item) => {
                if (item.petraId === message.videoPetraId) {
                    return {
                        ...item,
                        videoRecordStatus: message.videoStatus,
                    };
                }
                return item;
            });

            return { list: updatedList };
        });
        // jeśli NOTIFICATION_UPDATE dotyczy aktualnego filmu w dialogu
        if (element && message.videoPetraId === element.petraId) {
            if (message.videoStatus === 'READY') {
                this.setState({
                    videoLoading: false,
                    video: transactionVideoResponse?.videos
                });
            } else if (message.videoStatus === 'ERROR') {
                this.setState({
                    videoLoading: false,
                    videoDialogVisibile: false
                });
                this.showErrorMessage("Błąd podczas pobierania nagrań z serwera");
            }
        }
    };
    
    handleCloseVideoDialog(id, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({videoDialogVisibile: false, video: undefined, element: null, videoLoading: false, playerActiveIndex: 0 });

        // zatrzymanie pollingu, jeśli działa
        this.stopPolling()
    }

    handleOpenDialog(rowData, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: true, element: rowData});
    }

    handleCloseDialog(id, e) {
        if (e) {
            e.preventDefault();
        }
        this.setState({dialogVisibile: false, element: undefined});
    }

    videoTemplate(rowData) {
        const {t} = this.props;
        if (rowData.videoRecord && this.authService.getProfile().helpdeskUserRole  !== 'SALES_REPRESENTATIVE' &&  this.authService.getProfile().helpdeskUserRole !== 'REGIONAL_MANAGER') {
            return (
                <a onClick={this.handleClickOnVideo.bind(this, rowData)} role='button' tabIndex='0' href='#'>
                    <img
                        className='video-record'
                        alt={t('transaction.video')}
                        src={rowData.videoRecordStatus === 'READY' ? '/images/ico_video.svg' : '/images/ico_video_inactive.svg'}
                    />
                </a>
            );
        }
    }

    amountTemplate(field, rowData) {
        const {t} = this.props;
        return (
            <span className='invoice-amount-container'>
                <span className='invoice-amount'>
                    {t('invoice.amountGross')}
                    <NumberFormat
                        value={rowData.amount}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
                <span className='invoice-amount-vat'>
                    {t('invoice.amountVat')}
                    <NumberFormat
                        value={rowData.amountVat}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
                <span className='invoice-amount-netto'>
                    {t('invoice.amountNet')}
                    <NumberFormat
                        value={rowData.amountNet}
                        displayType={'text'}
                        thousandSeparator=' '
                        decimalSeparator=','
                        fixedDecimalScale
                        decimalScale={2}
                        suffix={` ${t('currency.pln')}`}
                        renderText={(value) => value}
                    />
                </span>
            </span>
        );
    }

    actionTemplate(rowData) {
        const {t} = this.props;
        return (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a onClick={this.handleOpenDialog.bind(this, rowData)} role='button' tabIndex='0'>
                <img className='card-icon' alt={t('transaction.details')} src={`/images/ico_chewron_right.svg`} />
            </a>
        );
    }

    generateReport(format) {
        const {t} = this.props;
        const list = [];
        if (this.state.selectedList) {
            this.state.selectedList.forEach((e) => {
                e.positions.forEach((p) => {
                    list.push({
                        dateTime: e.dateTime,
                        cardNumber: e.cardNumber,
                        registrationNumber: e.registrationNumber,
                        driver: e.driver,
                        stationName: e.stationName,
                        stationNumber: e.stationNumber,
                        productName: t(`products.${p.name}`),
                        measureUnit: t(`measureUnit.${p.measureUnit}`),
                        quantity: p.quantity,
                        amount: p.gross,
                        amountNet: p.netto,
                        amountVat: p.vat,
                        priceBefore: p.priceTotBefore,
                        discount: p.discount,
                        price: p.priceTotAfter,
                        odometer: e.odometer,
                        invoiceNo: p.invoiceNo,
                    });
                });
            });
        }
        if (format === 'csv') {
            const fields = [
                {value: this.dateTemplate.bind(this, 'dateTime', 'DD-MM-YYYY HH:mm:ss'), label: t('transaction.date')},
                {value: 'cardNumber', label: t('transaction.cardNumber')},
                {value: 'registrationNumber', label: t('transaction.registrationNumber')},
                {value: 'driver', label: t('transaction.fullName')},
                {value: 'stationName', label: t('transaction.city')},
                {value: 'stationNumber', label: t('transaction.stationNumber')},
                {value: 'productName', label: t('transaction.product')},
                {value: 'measureUnit', label: t('transaction.unit')},
                {value: 'quantity', label: t('transaction.quantity')},
                {value: 'amount', label: t('transaction.amountGross')},
                {value: 'amountNet', label: t('transaction.amountNet')},
                {value: 'amountVat', label: t('transaction.amountVat')},
                {value: 'priceBefore', label: t('transaction.priceUnitBefore')},
                {value: 'discount', label: t('transaction.priceUnitDiscount')},
                {value: 'price', label: t('transaction.priceUnitAfter')},
                {value: 'odometer', label: t('transaction.odometer')},
                {value: 'invoiceNo', label: t('transaction.invoiceNumber')},
            ];
            return Promise.resolve(baseReportCsv(list, fields));
        } else {
            const columns = [
                {
                    header: t('transaction.date'),
                    field: 'dateTime',
                    getColFunction: this.dateTemplate.bind(this, 'dateTime', 'DD-MM-YYYY HH:mm:ss'),
                },
                {field: 'cardNumber', header: t('transaction.cardNumber')},
                {field: 'registrationNumber', header: t('transaction.registrationNumber')},
                {field: 'driver', header: t('transaction.fullName')},
                {field: 'stationName', header: t('transaction.city')},
                {field: 'stationNumber', header: t('transaction.stationNumber')},
                {field: 'productName', header: t('transaction.product')},
                {field: 'measureUnit', header: t('transaction.unit')},
                {field: 'quantity', header: t('transaction.quantity')},
                {
                    header: t('transaction.amountGross'),
                    field: 'amount',
                    getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'amount', t) : null,
                },
                {
                    header: t('transaction.amountNet'),
                    field: 'amountNet',
                    getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'amountNet', t) : null,
                },
                {
                    header: t('transaction.amountVat'),
                    field: 'amountVat',
                    getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'amountVat', t) : null,
                },
                {
                    header: t('transaction.priceUnitBefore'),
                    field: 'priceBefore',
                    getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'priceBefore', t) : null,
                },
                {
                    header: t('transaction.priceUnitDiscount'),
                    field: 'discount',
                    getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'discount', t) : null,
                },
                {
                    header: t('transaction.priceUnitAfter'),
                    field: 'price',
                    getColFunction: format === 'pdf' ? currencyFormat.bind(this, 'price', t) : null,
                },
                {field: 'odometer', header: t('transaction.odometer')},
                {field: 'invoiceNo', header: t('transaction.invoiceNumber')},
            ];
            if (format === 'pdf') {
                const blob = baseReportPdf({list, title: t(this.getListTitle()), columns, landscape: true}, this.props.t);
                return Promise.resolve(blob);
            } else if (format === 'ods' || format === 'xlsx') {
                const request = {};
                request.columns = columns;
                request.list = list;
                request.sheetName = t(this.getListTitle()).replaceAll(/[*?\][\\/]/g, ' ,');
                return Promise.resolve(baseXLSXReport(request, format));
            }
        }
    }
    prepareHeaderItems() {
        return [
            {type: 'LABEL', className: 'float-left'},
            {
                type: 'BUTTON',
                className: 'right-side',
                variant: 'white',
                disabled: !this.state.selectedList || this.state.selectedList.length < 1,
                customRenderFunction: this.renderPrintButton,
            },
        ];
    }

    render() {
        const {t} = this.props;
        return (
            <div className='transaction-list-container' key='transaction-list-div'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                <BlockUi
                    tag='div'
                    blocking={(this.state.blocking && this.state.videoLoading === false) || this.state.loading }
                    loader={this.loader}
                    rendered={!this.props.embedded}
                >
                    {!!this.state.element && this.state.dialogVisibile ? (
                        <TransactionDialog
                            element={this.state.element}
                            onHide={(e) => this.handleCloseDialog(e)}
                            visible={this.state.dialogVisibile}
                            viewMode={this.state.dialogViewMode}
                            afterSave={(e) => this.refreshTable()}
                            blockUi={this.blockUi}
                            unblockUi={this.unblockUi}
                            embedded
                            showMessage={this.showMessage}
                            className='transaction-dialog'
                        />
                    ) : null}
                    {this.state.videoDialogVisibile && (
                        <CustomDialog
                            id={`video-dialog-${this.state.video?.petraId}`}
                            name='video-dialog'
                            element={this.state.video}
                            onHide={(e) => this.handleCloseVideoDialog(e)}
                            visible={this.state.videoDialogVisibile}
                            viewMode={this.state.dialogViewMode}
                            className='transaction-video-dialog'
                            afterSave={(e) =>
                                this.handleCloseDialog(e, () => {
                                    this.readMessage();
                                    this.refreshTable();
                                })
                            }
                            blockUi={this.blockUi}
                            unblockUi={this.unblockUi}
                            showMessage={this.showMessage}
                            header={t('transaction.videoDialogHeader', { videoDate: moment(this.state.element?.date).format('DD-MM-YYYY'), videoCardNo: this.state.element?.cardNumber })}
                        >
                            {this.state.videoLoading || !this.state.video ? (
                                <div className="spinner-wrapper">
                                    <ProgressSpinner /> 
                                    <p>Przygotowywanie streamingu video...</p>
                                </div>
                            ) : (
                                this.returnHlsPlayer()

                            )}
                        </CustomDialog>
                    )}
                   
                    <BreadcrumbsItem to='/transaction-list'>{t('invoice.listName')}</BreadcrumbsItem>
                    {this.renderAddToTrustedDevicesDialog()}
                    {this.renderView()}
                </BlockUi>
            </div>
        );
    }

    refreshCurrentTab(data) {
        this.setState((prevState) => ({
//            playerActiveIndex: prevState.playerActiveIndex,
            refreshKey: Date.now()
        }));

        const { element } = this.state;
        this.service.checkTransactionVideoStartStreaming({
            petraId: element?.petraId,
            cardNumber: element?.cardNumber,
            dateTime: element?.dateTime,
            subscribedPetraId: element?.petraId,
        })
    };

    returnHlsPlayer() {
        const { t } = this.props;
        const { playerActiveIndex, video, transactionVideoResponse } = this.state;

        return (
            <div className="hls-tabs-container-custom"> 
                <TabView
                    activeIndex={playerActiveIndex}
                    onTabChange={this.handleTabChange}
                >
                    {video?.map(v => {
                        const textHeader = t(`transaction.cameraPosition.${v.cameraPosition}`);
                        const path = v.videoMntPath;
                        const resultPath = path.split("TV_")[1];
                        return (
                            <TabPanel header={textHeader}>
                                <div className="video-tabs-custom"> 
                                    <HlsPlayerCustomBar
                                        key={`${v.index}-${playerActiveIndex}-${this.state.refreshKey}`}
                                        src={`${process.env.REACT_APP_BACKEND_URL}/transaction/${resultPath}?token=${this.authService.getToken()}`}
                                        controls
                                        videoStatus={v.videoRecordPartStatus}
                                        totalDuration={transactionVideoResponse?.videoDuration}
                                        onReady={() => this.unblockUi()}
                                        onRefresh={() => this.refreshCurrentTab(transactionVideoResponse)}
                                    />
                                </div>
                            </TabPanel>
                        );
                    })}
                </TabView>
            </div>
        );
    }

    renderView() {
        return (
            <DivContainer colClass=''>
                <Card
                    className='list-card card-list-container'
                    // header={this.renderHeader()}
                >
                    <DivContainer rendered={!this.props.hideFilters} colClass='row'>
                        {this.renderFilter()}
                    </DivContainer>
                    <DivContainer colClass='row'>{this.renderHeader()}</DivContainer>
                    {this.renderDataTable(this.prepareColumns())}
                </Card>
            </DivContainer>
        );
    }
}

TransactionListContainer.defaultProps = {
    detailUrl: '/#/invoice/details',
    newUrl: '/#/invoice/create',
    lazy: true,
    disableSelection: false,
    unInvoiced: undefined,
    hideFilters: false,
    selectionMode: 'multiple',
};

TransactionListContainer.propTypes = {
    detailUrl: PropTypes.string,
    newUrl: PropTypes.string,
    phoneNumber: PropTypes.string,
    unInvoiced: PropTypes.bool,
    hideFilters: PropTypes.bool,
};

export default withTranslation()(TransactionListContainer);
